/** Pre-orders are held for exactly this long after creation. The server is authoritative. */
export const ORDER_HOLD_HOURS = 24;

/** Legal minimum age for every sale (store-configurable from Phase 14). */
export const MINIMUM_AGE = 21;

/** Header every cookie-authenticated refresh/logout call must send (forces a CORS preflight). */
export const CSRF_HEADER = 'x-hutdrop-csrf';

export const CUSTOMER_REFRESH_COOKIE = 'sd_rt';
export const STAFF_REFRESH_COOKIE = 'sd_admin_rt';

export const CUSTOMER_AUTH_PATH = '/v1/auth';
export const STAFF_AUTH_PATH = '/v1/admin/auth';

/** Copy shown wherever an order is summarised. Never shorten the payment/ID wording. */
/**
 * FDA required warning statement for nicotine-containing products (21 CFR 1143.3). Counsel confirms placement
 * and size requirements for online listings in the Phase 20 legal review.
 */
export const NICOTINE_WARNING = 'WARNING: This product contains nicotine. Nicotine is an addictive chemical.';

/** Store-chosen notices for products containing Nixodine or THCA. */
export const NIXODINE_WARNING = 'This product contains Nixodine';
export const THCA_WARNING = 'This product contains THCA';

export const PICKUP_DISCLOSURES = {
  notPaid: 'Your order is not paid for yet. Payment is made in store when you pick up your order.',
  idRequired: 'A valid government-issued photo ID is required at pickup. Your QR code does not replace ID.',
  notGuaranteed:
    'A pre-order does not guarantee fulfillment. The store may refuse any sale where required by law.',
} as const;
